import axios from "axios";

import store from "../../store";
import { APIBaseUrl } from "../constance";
import { decryptPayload } from "../../shared/helper/common";
import { logoutUser } from "../../store/user/user-action";

export const defaultAxios = axios.create({
  // baseURL: APIBaseUrl,
  baseURL: "http://51.159.0.19:8001/api",
});

const handleLogout = async () => {
  await logoutUser();
};

// Request interceptor for authorization token
defaultAxios.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state?.user?.token ?? "";
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

defaultAxios.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      if (response.data && response.data.auth) {
        const decryptedData = decryptPayload(response.data.auth);
        return decryptedData;
      }
      return response.data;
    } else {
      return Promise.reject({ messages: ["Unknown error occurred"] });
    }
  },
  (error) => {
    const status = error.response?.status;
    const data = error.response?.data;

    if (status === 401) {
      console.error("Unauthorized, logging out...");
      handleLogout();
    }

    return Promise.reject({
      success: false,
      status: status || 500,
      message:
        data?.message ||
        error.message ||
        "Something went wrong while api failed.",
      data: data?.data || null,
      errors: data?.errors || [],
    });
  },
);
